import { preLoad } from "../include/module";
import { anchorLink } from "../include/module";
import { pickupSlider } from "../include/module";
import { toggleMenu } from "../include/module";
import { animParticle } from "../include/module";
import { sideToggle } from "../include/module";
import { loadingToggle } from "../include/module";
import { parallax } from "../include/module";
import { charaHover } from "../include/module";
import { scrollAnim } from "../include/module";
import { loadAnim } from "../include/module";





(() => {

  preLoad();
  anchorLink();
  pickupSlider();
  toggleMenu();
  sideToggle();
  loadingToggle();
  parallax();
  charaHover();
  scrollAnim();
  loadAnim();
  animParticle();

})();

// Index Cloud Animation
const animClouds = (target) => {
  var elm   = document.getElementById(target);
  var elmHeight = elm.clientHeight;
  var windowWidth = window.innerWidth;
  const app = new PIXI.Application({width: 1920, height: 1084,transparent : true});
  elm.appendChild(app.view);

  app.stage.interactive = true;

  const container = new PIXI.Container();
  app.stage.addChild(container);

  var texture = PIXI.Texture.from('/wp/wp-content/themes/nine-project/assets/images/common/common/bg_cloud.png');

  var clouds = new PIXI.TilingSprite(texture);
  container.addChild(clouds);


  const displacementSprite = PIXI.Sprite.from('/wp/wp-content/themes/nine-project/assets/images/common/common/filter_map.jpg');

  displacementSprite.texture.baseTexture.wrapMode = PIXI.WRAP_MODES.REPEAT;
  const displacementFilter = new PIXI.filters.DisplacementFilter(displacementSprite);
  displacementFilter.padding = 0;

  displacementSprite.position = clouds.position;

  app.stage.addChild(displacementSprite);

  clouds.filters = [displacementFilter];


  displacementFilter.scale.x = 0.05*app.renderer.width;
  displacementFilter.scale.y = 0.05*app.renderer.width;

  app.ticker.add(() => {
      displacementSprite.x += 0.75;
      clouds.tilePosition.x += 0.25;
      if (displacementSprite.x > displacementSprite.width) {
        displacementSprite.x = 0;
      }
  });
  $(window).on("load resize", function () {
    app.renderer.resize(window.innerWidth, window.innerHeight);
    clouds.width = 3800/1920 * app.screen.width;
    clouds.height = app.screen.height;
    // clouds.tileScale.x = window.innerWidth / 1920;
    clouds.tileScale.y = window.innerHeight / 1084;
  });
}
var userAgent = window.navigator.userAgent.toLowerCase();
if (/iPad|Macintosh/i.test(navigator.userAgent)&& 'ontouchend' in document || userAgent.indexOf('msie') != -1 || userAgent.indexOf('trident') != -1){
} else {
  // animClouds("mainvisual");
}



// WEBPACK FOOTER //
// ./src/assets/js/index/script.js